import { tl } from '@doda/common/src/utils/adobeAnalyticsUtil';
import { dataLayer } from '@doda/common/src/utils/googleTagManagerUtil';
import { QUERY_PARAMS } from '@doda/common/src/constants/queryParams';

/**
 * 求人ランキングが画面上に表示された際の計測発火
 * @param queryKey クエリのキー（oc,haなど）
 * @param queryValue クエリの値（01L,13,50など） 年収の場合は下限区分のみが渡される想定
 * @param jobIdList ランキング上に表示された求人のIDリスト 最大3件を想定
 */
export const measureRankingVisible = (
  queryKey: string,
  queryValue: string,
  jobIdList: string[]
) => {
  // 年収の場合は上限区分無しとして%2C0を付与する
  const value = queryKey === QUERY_PARAMS.ha ? `${queryValue}%2C0` : queryValue;

  tl(`recommendVisible:JobRanking_link_${queryKey}__${value}`, {
    linkTrackVars: 'eVar181,eVar182,eVar183,eVar184',
    linkTrackEvents: 'None',
    eVar181: String(jobIdList.length),
    eVar182: jobIdList.slice(0, 23).join(','),
    // 4件以上の求人が表示されることは無いため、eVar183,184は実装しない
  });
};

/**
 * 人気求人ランキングページリンク押下時の計測発火
 */
export const measureJobRankingClick = () => {
  tl('Jobsearchlist_jobranking_click', {});
};

/**
 * 求人ランキング上の気になるボタン押下時の計測発火
 * @param jobId 求人ID
 */
export const measureBookmarkClick = (jobId: string) => {
  tl('kininaruClick_JobRanking_link', {
    linkTrackVars: 'events,prop23,eVar23',
    linkTrackEvents: 'event120',
    products: `;${jobId}`,
    prop23: 'kininaru_Click',
    prop32: jobId,
    eVar23: 'kininaru_Click',
    events: 'event120',
  });
  dataLayer({
    JobId: jobId,
    event: 'bookmark_click',
  });
};
